module.exports = __webpack_public_path__ + "img/Sustainable scalability 1.9e215a77.svg";